export default __webpack_public_path__ + "static/media/chrome-light.78e3c197.svg";